/**
 * cep-lookup - Busca de endereço por CEP (ViaCEP), mesma regra do modal de Cliente.
 *
 * RELEASE: 2026-10-06 v1.0.0 - Versão inicial (extraída do CustomerFormDialog para reúso em Pessoas).
 */

export interface CepAddress {
  street: string;
  district: string;
  city: string;
  state: string;
}

/**
 * Retorna o endereço do CEP ou lança erro com mensagem amigável.
 * Aceita CEP com ou sem máscara; exige 8 dígitos.
 */
export async function fetchAddressByCep(rawCep: string | null | undefined): Promise<CepAddress> {
  const cep = (rawCep || '').replace(/\D/g, '');
  if (cep.length !== 8) throw new Error('CEP inválido. Digite 8 dígitos.');
  let data: Record<string, string> & { erro?: boolean };
  try {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    data = await response.json();
  } catch {
    throw new Error('Erro ao buscar CEP. Tente novamente.');
  }
  if (data.erro) throw new Error('CEP não encontrado.');
  return {
    street: data.logradouro || '',
    district: data.bairro || '',
    city: data.localidade || '',
    state: data.uf || '',
  };
}
